// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"2ffccbd0","768":"8ebb743e","848":"39ab0033"}[chunkId] + ".chunk.js";
};